<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!--页头-->
              <div class="page_header">
                Root Cause Analysis and Solution Plan
              </div>
              <!--页头-->
              <div class="page_main">
                <el-form
                  ref="form"
                  :model="info"
                  label-position="top"
                  class="request-form"
                >
                  <el-form-item label="CAPA ID" class="full-width-item">
                    <div class="gray-input">
                      {{ info.request_id || "/" }}
                    </div>
                  </el-form-item>
                  <div class="form-grid">
                    <!-- 左侧 -->
                    <div class="form-col">
                      <el-form-item label="Status">
                        <div class="gray-input">
                          {{ info.status_name || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Priority">
                        <div class="gray-input">
                          <span v-if="info.priority == 1">High</span>
                          <span v-if="info.priority == 2">Medium</span>
                          <span v-if="info.priority == 3">Low</span>
                          <span v-if="!info.priority">/</span>
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigator">
                        <div class="gray-input">
                          {{ info.investigator || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                    <!-- 右侧 -->
                    <div class="form-col">
                      <el-form-item label="Request Date">
                        <div class="gray-input">
                          {{ info.time1 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Acceptance Date">
                        <div class="gray-input">
                          {{ info.time2 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Start Date">
                        <div class="gray-input">
                          {{ info.time3 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Completion Date">
                        <div class="gray-input">
                          {{ info.time4 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Start Date">
                        <div class="gray-input">
                          {{ info.time5 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Completion Date">
                        <div class="gray-input">
                          {{ info.time6 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Close Date">
                        <div class="gray-input">
                          {{ info.pass_time || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="text-tip">CAPA Description</div>
                  <el-form-item
                    label="Description of the Issue, Concern, Idea, or Opportunity"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.description || "/" }}
                    </div>
                  </el-form-item>
                  <div class="text-tip">Background Information</div>
                  <div class="form-grid">
                    <!-- 左侧 -->
                    <div class="form-col">
                      <el-form-item label="Requester">
                        <div class="gray-input">
                          {{ info.username || "/" }}
                        </div>
                      </el-form-item>
                     <!-- <el-form-item label="Company">
                        <div class="gray-input">
                          {{ info.company_name || "/" }}
                        </div>
                      </el-form-item> -->
                    </div>
                    <!-- 右侧 -->
                    <div class="form-col">
                      <el-form-item label="Source Type">
                        <div class="gray-input">
                          {{ info.source_type || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Department">
                        <div class="gray-input">
                          {{ info.departments_name || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <el-form-item
                    label="Source Information"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.source_info || "/" }}
                    </div>
                  </el-form-item>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">CAPA Background Files</div>
                    </div>
                    <el-table
                      :data="backdocTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Description"
                        prop="description"
                        min-width="300"
                      />
                      <el-table-column
                        label="File Name"
                        prop="name"
                        min-width="300"
                      >
                        <template #default="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">
                        Articles Affected by the Issue, Concern, Idea, or
                        Opportunity
                      </div>
                    </div>
                    <el-table
                      :data="affectArticleTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop=""
                        label="Article Type"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.article_type == 1">Document</div>
                          <div v-if="scope.row.article_type == 2">
                            Equipment
                          </div>
                          <div v-if="scope.row.article_type == 3">Product</div>
                          <div v-if="scope.row.article_type == 4">Tool</div>
                          <div v-if="scope.row.article_type == 5">Other</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="article_id"
                        label="Article ID"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_name"
                        label="Article Name"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_revision"
                        label="Article Revision"
                        min-width="140"
                        sortable
                      ></el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Serial Number"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.serial_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Lot Number"
                        min-width="160"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.lot_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Purchased Product?"
                        min-width="200"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.is_buy == 1">Yes</div>
                          <div v-if="scope.row.is_buy == 2">No</div>
                          <div v-else></div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Supplier"
                        min-width="200"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.supplier_name || "" }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 调查活动日志 -->
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">Correction</div>
                    </div>
                    <el-table
                      :data="investigationLogTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No activity log entries"
                    >
                      <el-table-column
                        v-if="step < 5"
                        label="Action"
                        width="80"
                      >
                        <template slot-scope="scope">
                          <el-button
                            type="primary"
                            size="mini"
                            @click="handleAddActivityLog(scope.row)"
                          >
                            Edit
                          </el-button>
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="description"
                        label="Description"
                        min-width="260"
                        sortable
                      />

                      <el-table-column
                        prop=""
                        label="Created Time"
                        min-width="120"
                        sortable
                      >
                        <template #default="scope">
                          {{ initTime(scope.row.update_time) }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop=""
                        label="Last Updated"
                        min-width="140"
                        sortable
                      >
                        <template #default="scope">
                          {{ initTime(scope.row.dateline) }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="attachment"
                        label="Attachments"
                        min-width="160"
                      >
                        <template #default="scope">
                          <div
                            v-for="(value, index) in scope.row.filelist"
                            :key="index"
                            style="padding: 4px 0"
                          >
                            <a :href="value.url" target="_blank">
                              {{ value.name }}
                            </a>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>

                    <el-button
                      type="primary"
                      size="mini"
                      style="margin: 10px"
                      @click="handleActivityLog"
                    >
                      Add Activity Log Entry
                    </el-button>
                  </div>

                  <div class="yellow-tip">
                    Record the actions taken to investigate and eliminate the
                    identified nonconformities.
                  </div>

                  <!-- Correction -->
                  <div class="section-panel">
                    <div class="panel-header">
                      <div class="table-title">Correction</div>
                    </div>

                    <el-table
                      :data="correctionTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop="description"
                        label="Correction Description"
                        min-width="260"
                        sortable
                      />

                      <el-table-column
                        prop=""
                        label="Correction File"
                        min-width="180"
                      >
                        <template slot-scope="scope">
                          <a :href="scope.row.url" target="_blank">
                            {{ scope.row.name }}
                          </a>
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-if="step < 5"
                        label="Action"
                        width="80"
                      >
                        <template slot-scope="scope">
                          <el-button
                            type="danger"
                            size="mini"
                            @click="handleDeleteCorrection(scope.row)"
                          >
                            Delete
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>

                    <el-button
                      type="primary"
                      size="mini"
                      style="margin: 12px 10px 0px 10px"
                      @click="handleEditCorrection"
                    >
                      Add Correction
                    </el-button>
                  </div>
                  <!-- 解决方案计划说明 -->
                  <div class="yellow-tip list-tip">
                    <div>
                      The following items must be completed to develop a
                      Solution Plan:
                    </div>
                    <ul>
                      <li>
                        Perform a root cause analysis and identify improvement
                        actions for the identified root causes or weaknesses.
                      </li>
                      <li>
                        For each root cause, add one or more actions to the
                        Solution Plan.
                      </li>
                      <li>
                        For each action, specify the assigned owner and the
                        planned completion date.
                      </li>
                      <li>
                        Use the "Solution Impact" field to describe the
                        potential impact of the proposed actions on production
                        and the type of change approval required.
                      </li>
                      <li>
                        Use the "Show Solution Details / Show Solution Summary"
                        button to switch between the detailed view and summary
                        view of the Solution Plan.
                      </li>
                    </ul>
                  </div>

                  <div class="solution-plan">
                    <!-- Header -->
                    <div class="plan-header">
                      <span class="plan-title">Solution Plan</span>
                      <el-button
                        type="text"
                        class="toggle-btn"
                        @click="toggleAll"
                      >
                        {{ allExpanded ? "Collapse All" : "Expand All" }}
                        <i
                          :class="
                            allExpanded
                              ? 'el-icon-arrow-up'
                              : 'el-icon-arrow-down'
                          "
                        ></i>
                      </el-button>

                      <el-button
                        type="primary"
                        size="mini"
                        class="section-add-btn"
                        @click="handleAddRootCase"
                      >
                        Add Root Cause
                      </el-button>
                    </div>

                    <!-- Content -->
                    <div
                      class="plan-card"
                      v-for="(item, index) in rootCause"
                      :key="index"
                    >
                      <!-- Root Cause -->
                      <section class="plan-section">
                        <div class="plan-header">
                          <span class="plan-title">Root Cause</span>

                          <el-button
                            type="primary"
                            size="mini"
                            class="section-add-btn"
                            @click="handleAddOperation(item)"
                          >
                            Add Action
                          </el-button>

                          <el-button
                            type="primary"
                            size="mini"
                            class="section-add-btn"
                            @click="handleRootCaseEdit(item)"
                          >
                            Edit
                          </el-button>

                          <el-button
                            type="primary"
                            size="mini"
                            class="section-add-btn"
                            @click="handleRootCaseDel(item)"
                          >
                            Delete
                          </el-button>
                        </div>

                        <div class="form-block">
                          <el-form-item label="Root Cause Analysis Result">
                            <div class="gray-input">
                              {{ item.analysis_results }}
                            </div>
                          </el-form-item>
                        </div>

                        <template
                          v-if="rootCauseExpanded == item.id || allExpanded"
                        >
                          <div class="form-grid">
                            <!-- Left -->
                            <div class="form-col">
                              <el-form-item
                                label="Is this root cause related to a supplier?"
                              >
                                <div class="gray-input">
                                  {{ item.is_supplier == 1 ? "Yes" : "No" }}
                                </div>
                              </el-form-item>
                            </div>

                            <!-- Right -->
                            <div class="form-col">
                              <el-form-item label="Supplier">
                                <div class="gray-input">
                                  {{ item.supplier_name }}
                                </div>
                              </el-form-item>
                            </div>
                          </div>

                          <div class="custom-panel">
                            <div class="panel-header">
                              <div class="table-title">
                                Root Cause Analysis Files
                              </div>
                            </div>

                            <el-table
                              :data="item.filelist"
                              border
                              stripe
                              header-cell-class-name="table-header-cell"
                              class="file-table"
                              empty-text="No root cause analysis files"
                            >
                              <el-table-column
                                prop=""
                                label="Description"
                                sortable
                                min-width="200"
                              >
                                <template slot-scope="scope">
                                  <div>{{ scope.row.description || "/" }}</div>
                                </template>
                              </el-table-column>

                              <el-table-column
                                prop="fileName"
                                label="File Name"
                                min-width="240"
                              >
                                <template slot-scope="scope">
                                  <a :href="scope.row.url" target="_blank">
                                    {{ scope.row.name }}
                                  </a>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </template>

                        <div v-if="!allExpanded" class="section-toggle">
                          <el-button
                            type="text"
                            @click="rootCauseExpandedClick(item)"
                          >
                            {{
                              rootCauseExpanded == item.id || allExpanded
                                ? "Collapse"
                                : "Expand"
                            }}
                            <i
                              :class="
                                rootCauseExpanded == item.id || allExpanded
                                  ? 'el-icon-arrow-up'
                                  : 'el-icon-arrow-down'
                              "
                            ></i>
                          </el-button>
                        </div>
                      </section>

                      <!-- Divider -->
                      <div class="divider"></div>

                      <!-- Corrective / Preventive Actions -->
                      <div
                        class="plan-card"
                        v-for="(item2, index2) in item.caparootcauseaction_list"
                        :key="index2"
                        style="padding-left: 30px"
                      >
                        <section class="plan-section">
                          <div class="plan-header">
                            <span class="plan-title">
                              {{
                                item2.capa_type == 1
                                  ? "Corrective Action"
                                  : "Preventive Action"
                              }}
                            </span>

                            <el-button
                              type="primary"
                              size="mini"
                              class="section-add-btn"
                              @click="handleMeasureEdit(item2, item)"
                            >
                              Edit
                            </el-button>

                            <el-button
                              type="primary"
                              size="mini"
                              class="section-add-btn"
                              @click="handleMeasureDel(item2)"
                            >
                              Delete
                            </el-button>
                          </div>

                          <div class="form-block">
                            <el-form-item
                              label="Action Implementation Description"
                            >
                              <div class="gray-input">
                                {{ item2.implementation_instructions }}
                              </div>
                            </el-form-item>
                          </div>

                          <template
                            v-if="correctiveExpanded == item2.id || allExpanded"
                          >
                            <div class="form-block">
                              <el-form-item label="Assigned To">
                                <div class="gray-input">
                                  {{ item2.implementor_username }}
                                </div>
                              </el-form-item>
                            </div>

                            <div class="form-block">
                              <el-form-item label="Planned Completion Date">
                                <div class="gray-input">
                                  {{ initTime2(item2.end_time) }}
                                </div>
                              </el-form-item>
                            </div>

                            <div class="custom-panel">
                              <div class="panel-header">
                                <div class="table-title">Affected Files</div>
                              </div>

                              <el-table
                                :data="item2.filelist"
                                border
                                stripe
                                header-cell-class-name="table-header-cell"
                                class="file-table"
                                empty-text="No affected files"
                              >
                                <el-table-column
                                  prop=""
                                  label="Description"
                                  sortable
                                  min-width="200"
                                >
                                  <template slot-scope="scope">
                                    <div>
                                      {{ scope.row.description || "/" }}
                                    </div>
                                  </template>
                                </el-table-column>

                                <el-table-column
                                  prop="fileName"
                                  label="File Name"
                                  min-width="240"
                                >
                                  <template slot-scope="scope">
                                    <a :href="scope.row.url" target="_blank">
                                      {{ scope.row.name }}
                                    </a>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>

                            <div class="form-block" style="margin-top: 20px">
                              <el-form-item label="Verification Description">
                                <div class="gray-input">
                                  {{ item2.verification_instructions }}
                                </div>
                              </el-form-item>
                            </div>
                          </template>

                          <div v-if="!allExpanded" class="section-toggle">
                            <el-button
                              type="text"
                              @click="correctiveExpandedClick(item2)"
                            >
                              {{
                                correctiveExpanded == item2.id || allExpanded
                                  ? "Collapse"
                                  : "Expand"
                              }}
                              <i
                                :class="
                                  correctiveExpanded == item2.id || allExpanded
                                    ? 'el-icon-arrow-up'
                                    : 'el-icon-arrow-down'
                                "
                              ></i>
                            </el-button>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                  <div class="yellow-tip" style="margin-bottom: 10px">
                    Click the "Describe Solution Impact" button to indicate
                    whether implementing this solution will change production
                    output and what type of change approval is required.
                  </div>

                  <!-- Solution Impact -->
                  <div class="section-block">
                    <div class="text-tip">Solution Impact</div>

                    <el-form-item label="Impacts Documents?">
                      <div class="gray-input">
                        <span v-if="ruleForm.impacts_documents == 1">Yes</span>
                        <span v-if="ruleForm.impacts_documents == 2">No</span>
                      </div>
                    </el-form-item>

                    <el-form-item label="Impacts Production Output?">
                      <div class="gray-input">
                        <span v-if="ruleForm.Impacts_product == 1">Yes</span>
                        <span v-if="ruleForm.Impacts_product == 2">No</span>
                      </div>
                    </el-form-item>

                    <el-form-item
                      label="Description of Impact on Production Output"
                    >
                      <div class="gray-input">
                        {{ ruleForm.Impacts_description || "/" }}
                      </div>
                    </el-form-item>

                    <el-form-item label="Change Approval Requirements">
                      <div class="gray-input">
                        {{ ruleForm.change_auth || "/" }}
                      </div>
                    </el-form-item>

                    <el-button
                      type="primary"
                      size="mini"
                      class="section-btn"
                      @click="handlelplanAffect"
                    >
                      Describe Solution Impact
                    </el-button>
                  </div>

                  <div class="yellow-tip list-tip" style="margin-bottom: 10px">
                    <div>
                      Click the "Edit CAPA Effectiveness Verification Plan"
                      button to indicate whether effectiveness verification is
                      required after all actions have been completed.
                    </div>
                    <ul>
                      <li>
                        If effectiveness verification is required, you can enter
                        instructions describing how the effectiveness of the
                        CAPA solution will be verified. Optionally, assign a
                        user to perform the verification and specify the due
                        date.
                      </li>
                      <li>
                        If effectiveness verification is not required, explain
                        why this CAPA request does not require effectiveness
                        verification.
                      </li>
                    </ul>
                  </div>

                  <!-- CAPA Effectiveness Verification Plan -->
                  <div class="section-block">
                    <div class="text-tip">
                      CAPA Effectiveness Verification Plan
                    </div>

                    <el-form-item
                      label="Does this CAPA request require effectiveness verification?"
                    >
                      <div class="gray-input">
                        <span v-if="ruleForm1.capa_verification == 1">Yes</span>
                        <span v-if="ruleForm1.capa_verification == 2">No</span>
                      </div>
                    </el-form-item>

                    <el-form-item
                      label="CAPA Effectiveness Verification Instructions"
                    >
                      <div class="gray-input">
                        {{ ruleForm1.capa_instructions }}
                      </div>
                    </el-form-item>

                    <el-form-item label="Verification Plan Assignee">
                      <div class="gray-input">
                        {{ ruleForm1.capa_instructions_username }}
                      </div>
                    </el-form-item>

                    <el-form-item label="Verification Plan Due Date">
                      <div class="gray-input">
                        {{ ruleForm1.capa_instructions_endtime }}
                      </div>
                    </el-form-item>

                    <el-form-item label="Reason Verification Is Not Required">
                      <div class="gray-input">
                        {{ ruleForm1.nocapa_reason }}
                      </div>
                    </el-form-item>

                    <el-button
                      type="primary"
                      size="mini"
                      class="section-btn"
                      @click="handleEffectiveVerification"
                    >
                      Edit CAPA Effectiveness Verification Plan
                    </el-button>
                  </div>

                  <!-- Footer Buttons -->
                  <div class="footer-btn">
                    <el-button type="primary" size="small" @click="handleLater">
                      Complete Later
                    </el-button>

                    <el-button
                      v-if="step == 4"
                      type="primary"
                      size="small"
                      @click="handleRequest"
                    >
                      Edit Request Information
                    </el-button>

                    <el-button
                      v-if="step == 4 || step == 5"
                      type="primary"
                      size="small"
                      @click="handleSubmit"
                    >
                      Submit Solution
                    </el-button>

                    <el-button
                      v-if="step == 5"
                      type="primary"
                      size="small"
                      @click="handleReject"
                    >
                      Reject Solution
                    </el-button>

                    <el-button
                      v-if="step == 5"
                      type="primary"
                      size="small"
                      @click="handleShelve"
                    >
                      Put Request on Hold
                    </el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <!--描述解决方案的影响弹框-->
    <el-dialog
      title="Describe the Impact of the Proposed Solution"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
          >
            <div class="yellow-tip" style="margin-bottom: 10px">
              Please indicate whether implementing this proposed solution will
              cause production output to deviate from the currently approved
              specifications. If "Yes", you must provide a description of the
              impact. If you are unable to accurately describe the impact on
              production output, please select "Unknown". The CAPA Module
              Coordinator will be required to answer this question.
            </div>

            <div class="input_el">
              <div class="tit required">Impacts Documents?</div>
              <el-form-item label="" prop="impacts_documents">
                <el-select
                  v-model="ruleForm.impacts_documents"
                  placeholder="Please select"
                  style="width: 100%"
                >
                  <el-option label="Yes" :value="1" />
                  <el-option label="No" :value="2" />
                </el-select>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">
                Will the proposed solution impact production output?
              </div>
              <el-form-item label="" prop="Impacts_product">
                <el-select
                  v-model="ruleForm.Impacts_product"
                  placeholder="Please select"
                  style="width: 100%"
                >
                  <el-option label="Yes" :value="1" />
                  <el-option label="No" :value="2" />
                </el-select>
              </el-form-item>
            </div>
            <div v-if="ruleForm.Impacts_product == 1" class="input_el">
              <div class="tit required">
                If yes, please describe the impact on production output.
              </div>
              <el-form-item label="" prop="Impacts_description">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="ruleForm.Impacts_description"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>

            <div
              v-if="ruleForm.Impacts_product == 1"
              class="yellow-tip"
              style="margin-bottom: 10px"
            >
              Please indicate what type of change authorization, if any, is
              required to implement the proposed solution.
            </div>

            <div v-if="ruleForm.Impacts_product == 1" class="input_el">
              <div class="tit required">
                What type of change authorization is required?
              </div>
              <el-form-item label="" prop="change_auth">
                <el-select
                  v-model="ruleForm.change_auth"
                  placeholder="Please select"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option label="Permanent" value="Permanent" />
                  <el-option label="Temporary" value="Temporary" />
                  <el-option label="None" value="None" />
                  <el-option label="Unknown" value="Unknown" />
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm('ruleForm')"
          >
            Confirm
          </van-button>
        </div>
      </div>
    </el-dialog>
    <!--描述解决方案的影响弹框-->
    <!--编辑 CAPA 有效性验证计划弹框-->
    <el-dialog
      title="Edit CAPA Effectiveness Verification Plan"
      :visible.sync="dialogVisible1"
      width="50%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>

          <el-form
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleForm1"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">
                Does this CAPA request require CAPA effectiveness verification?
              </div>
              <el-form-item label="" prop="capa_verification">
                <el-select
                  v-model="ruleForm1.capa_verification"
                  placeholder="Please select"
                  style="width: 100%"
                >
                  <el-option label="Yes" :value="1" />
                  <el-option label="No" :value="2" />
                </el-select>
              </el-form-item>
            </div>

            <div v-if="ruleForm1.capa_verification == 1" class="input_el">
              <div class="tit required">
                CAPA Effectiveness Verification Instructions
              </div>
              <el-form-item label="" prop="capa_instructions">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="ruleForm1.capa_instructions"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>

            <div v-if="ruleForm1.capa_verification == 1" class="input_el">
              <div class="tit required">
                CAPA Effectiveness Verification Plan Assignee
              </div>
              <el-form-item label="" prop="capa_instructions_uid">
                <el-select
                  filterable
                  v-model="ruleForm1.capa_instructions_uid"
                  placeholder="Please select"
                  class="full-width"
                  clearable
                >
                  <el-option
                    v-for="value in usersList"
                    :key="value.id"
                    :label="value.username"
                    :value="value.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div v-if="ruleForm1.capa_verification == 1" class="input_el">
              <div class="tit required">
                CAPA Effectiveness Verification Plan Due Date
              </div>
              <el-form-item label="" prop="capa_instructions_endtime">
                <el-date-picker
                  v-model="ruleForm1.capa_instructions_endtime"
                  type="date"
                  placeholder="Please select"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </div>

            <div v-if="ruleForm1.capa_verification == 2" class="input_el">
              <div class="tit required">
                Reason Why CAPA Effectiveness Verification Is Not Required
              </div>
              <el-form-item label="" prop="nocapa_reason">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="ruleForm1.nocapa_reason"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible1 = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm1('ruleForm1')"
          >
            Confirm
          </van-button>
        </div>
      </div>
    </el-dialog>
    <!--编辑 CAPA 有效性验证计划弹框-->
    <!--签名弹框-->
    <el-dialog
      title="Submit Solution"
      :visible.sync="dialogVisible2"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>
          <el-form
            :model="ruleForm2"
            :rules="rules2"
            ref="ruleForm2"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit">Comments</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm2.remark"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm2.signature"
                  placeholder="Please enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible2 = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm2('ruleForm2')"
          >
            Sign
          </van-button>
        </div>
      </div>
    </el-dialog>

    <!-- Signature Dialog -->

    <!-- Initial Review Dialog -->
    <el-dialog
      title="Initial Review Signature"
      :visible.sync="dialogVisible3"
      width="50%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>

          <el-form
            ref="formRef"
            :model="ruleForm3"
            :rules="rules3"
            label-position="top"
            class="audit-form"
          >
            <el-row :gutter="24">
              <el-col
                v-for="(item, index) in ruleForm3.approvers"
                :key="index"
                :span="12"
              >
                <el-form-item
                  :label="item.label"
                  :prop="'approvers.' + index + '.value'"
                >
                  <el-select
                    filterable
                    v-model="item.value"
                    placeholder="Please select"
                    style="width: 100%"
                    clearable
                  >
                    <el-option
                      v-for="user in usersList2"
                      :key="user.id"
                      :label="user.username"
                      :value="user.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="Approval Due Date" prop="deadline" required>
              <el-date-picker
                v-model="ruleForm3.deadline"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="Please select a date"
                style="width: 100%"
              />
            </el-form-item>

            <el-form-item label="Comments" prop="comment">
              <el-input v-model="ruleForm3.comment" type="textarea" :rows="3" />
            </el-form-item>

            <el-form-item label="Signature Key" prop="signature" required>
              <el-input
                v-model="ruleForm3.signature"
                placeholder="Please enter your login password"
                show-password
              />
            </el-form-item>
          </el-form>
        </div>

        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible3 = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm3('formRef')"
          >
            Sign
          </van-button>
        </div>
      </div>
    </el-dialog>
    <!--初步审核弹框-->
    <!--拒绝解决方案计划弹框-->
    <el-dialog
      title="Reject Solution Plan"
      :visible.sync="dialogVisible4"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>

          <el-form
            :model="ruleForm4"
            :rules="rules4"
            ref="ruleForm4"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">Response Due Date</div>
              <el-form-item label="" prop="response_end_time">
                <el-date-picker
                  v-model="ruleForm4.response_end_time"
                  type="date"
                  placeholder="Please select"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Comments</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm4.remark"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm4.signature"
                  placeholder="Please enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible4 = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm4('ruleForm4')"
          >
            Sign
          </van-button>
        </div>
      </div>
    </el-dialog>

    <!-- Reject Solution Plan Dialog -->

    <!-- Defer CAPA Request Dialog -->
    <el-dialog
      title="Defer CAPA Request"
      :visible.sync="dialogVisible5"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>

          <el-form
            :model="ruleForm5"
            :rules="rules5"
            ref="ruleForm5"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">Priority</div>
              <el-form-item label="" prop="priority">
                <el-select
                  filterable
                  v-model="ruleForm5.priority"
                  placeholder="Please select"
                  class="full-width"
                  clearable
                >
                  <el-option label="High" value="1"></el-option>
                  <el-option label="Medium" value="2"></el-option>
                  <el-option label="Low" value="3"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Comments</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm5.remark"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm5.signature"
                  placeholder="Please enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible5 = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm5('ruleForm5')"
          >
            Sign
          </van-button>
        </div>
      </div>
    </el-dialog>
    <!--暂缓CAPA弹框-->
    <!--添加文件弹窗-->
    <el-dialog
      title="Add Correction Document"
      :visible.sync="dialogVisible6"
      width="50%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>

          <el-form
            ref="ruleForm6"
            :model="ruleForm6"
            :rules="rules6"
            label-position="top"
            class="upload-form"
          >
            <!-- Description -->
            <el-form-item label="Description" prop="description">
              <el-input
                v-model="ruleForm6.description"
                type="textarea"
                :rows="5"
                resize="none"
                placeholder="Please enter a description"
              />
            </el-form-item>

            <!-- Attachment -->
            <el-form-item prop="">
              <div class="upload-doc-wrapper">
                <div class="upload-title required-title">
                  <span>File to Upload</span>
                  <span class="upload-limit"> (Maximum 10 MB) </span>
                </div>

                <div class="upload-box" style="position: relative">
                  <el-upload
                    ref="uploadBox"
                    class="doc-upload"
                    action="/"
                    name="files"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :on-change="handleAvatarChange"
                    :limit="1"
                    :with-credentials="true"
                    :auto-upload="false"
                  >
                    <el-button size="medium" class="select-btn">
                      Select File
                    </el-button>
                  </el-upload>

                  <div class="file-name" :class="{ placeholder: !fileName }">
                    {{ fileName || "No file selected" }}
                    <span
                      v-if="fileName"
                      style="
                        position: absolute;
                        right: 20px;
                        top: 12px;
                        cursor: pointer;
                        color: #f00;
                      "
                      @click="delFile"
                    >
                      Delete
                    </span>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible6 = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm6('ruleForm6')"
          >
            Confirm
          </van-button>
        </div>
      </div>
    </el-dialog>
    <!--添加文件弹窗-->
  </div>
</template>

<script>
import { resourcesApplyDetail } from "@/api/docManage/changeRequest/index";
import {
  ApplyHandle,
  capaUploadsCapaCorrectionsFile,
  capaUploadsCapaCorrectionsFileDel,
  capaRootCauseDel,
  capaRootCauseActionDel,
  capaImpacts,
  capaVerification,
} from "@/api/capaManage/capaRequest/index";
import { capausersList } from "@/api/capaManage/configCapa/capaReview/index";
import { usersList } from "@/api/system/user";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from "js-md5";
import moment from "moment";
export default {
  name: "CapaDetail",
  components: {
    headers,
    slider,
  },
  data() {
    return {
      rootCauseExpanded: null,
      correctiveExpanded: null,
      allExpanded: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      usersList: [],
      usersList2: [],
      info: {},
      backdocTableData: [],
      affectArticleTableData: [],
      investigationLogTableData: [],
      correctionTableData: [], //更正表格
      rootCauseFiles: [],
      affectedFiles: [],
      rootCause: [], // 根本原因
      correctiveMeasures: [],
      ruleForm: {
        id: "",
        impacts_documents: "",
        Impacts_product: "",
        Impacts_description: "",
        change_auth: "",
      },
      rules: {
        impacts_documents: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        Impacts_product: [
          {
            required: true,
            message: "Please select",
            trigger: "blur",
          },
        ],
        Impacts_description: [
          {
            required: true,
            message: "Please enter",
            trigger: "change",
          },
        ],
        change_auth: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
      },
      ruleForm1: {
        id: "",
        capa_verification: "",
        capa_instructions: "",
        capa_instructions_uid: "",
        capa_instructions_endtime: "",
        nocapa_reason: "",
        capa_instructions_username: "",
      },
      rules1: {
        capa_verification: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        capa_instructions: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
        capa_instructions_uid: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        capa_instructions_endtime: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        nocapa_reason: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      ruleForm2: {
        remark: "",
        signature: "",
      },
      rules2: {
        signature: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      ruleForm3: {
        approvers: [
          {
            label: "Additional Approver 1",
            value: "",
          },
          {
            label: "Additional Approver 2",
            value: "",
          },
        ],
        deadline: "",
        comment: "",
        signKey: "",
      },

      rules3: {
        deadline: [
          {
            required: true,
            message: "Please select the approval due date",
            trigger: "change",
          },
        ],
        signature: [
          {
            required: true,
            message: "Please enter the electronic signature",
            trigger: "blur",
          },
        ],
      },
      ruleForm4: {
        response_end_time: "",
        remark: "",
        signature: "",
      },
      rules4: {
        response_end_time: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        remark: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
        signature: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      ruleForm5: {
        priority: "",
        remark: "",
        signature: "",
      },
      rules5: {
        priority: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        remark: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
        signature: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      step: null,
      fileName: "",
      selectedFile: null,
      dialogVisible6: false,
      ruleForm6: {
        capa_id: "",
        description: "",
        files: "",
      },
      rules6: {
        description: [
          {
            required: true,
            message: "Please enter comments",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    // allExpanded() {
    // 	return this.rootCauseExpanded && this.correctiveExpanded;
    // },
  },
  mounted() {
    let that = this;
    that.step = that.$route.query.step;
    //请求用户列表
    usersList({
      page: 1,
      page_size: 9999,
      status: 1,
    }).then((res) => {
      that.usersList = res.data.data;
      that.usersList2 = res.data.data;
    });
    //请求页面详情
    that.getPageInfo();
  },
  methods: {
    //请求页面详情
    getPageInfo() {
      let that = this;
      resourcesApplyDetail({
        id: that.$route.query.oid,
      }).then((res) => {
        if (res.code == 200) {
          // console.log(res.data);
          that.info = {
            ...that.info,
            id: res.data.id,
            request_id: res.data.request_id,
            status_name: res.data.status_name,
            priority: res.data.priority,
            investigator: res.data.investigator,
            description: res.data.description,
            username: res.data.username,
            // company_name: res.data.company_name,
            source_type: res.data.source_type,
            departments_name: res.data.departments_name,
            source_info: res.data.source_info,
            time1: res.data.time1,
            time2: res.data.time2,
            time3: res.data.time3,
            time4: res.data.time4,
            time5: res.data.time5,
            time6: res.data.time6,
            pass_time: res.data.pass_time,
            step_name: res.data.step_name,
          };
          // 回显CAPA背景文件
          that.backdocTableData = res.data.capabackground_list || [];
          // 回显更正文件
          that.correctionTableData = res.data.capacorrections_list || [];
          // 回显受影响的文章
          that.affectArticleTableData = res.data.capaarticle_list || [];
          // 活动日志
          that.investigationLogTableData = res.data.capaaffected_list || [];
          // 根本原因
          that.rootCause = res.data.caparootcause_list || [];
          // 解决方案的影响
          that.ruleForm.id = res.data.id;
          that.ruleForm.impacts_documents = res.data.impacts_documents
            ? res.data.impacts_documents
            : "";
          that.ruleForm.Impacts_product = res.data.Impacts_product
            ? res.data.Impacts_product
            : "";
          that.ruleForm.Impacts_description = res.data.Impacts_description;
          that.ruleForm.change_auth = res.data.change_auth;
          // CAPA有效性验证计划
          that.ruleForm1.id = res.data.id;
          that.ruleForm1.capa_verification = res.data.capa_verification
            ? res.data.capa_verification
            : "";
          that.ruleForm1.capa_instructions = res.data.capa_instructions;
          that.ruleForm1.capa_instructions_endtime = res.data
            .capa_instructions_endtime
            ? that.initTime2(res.data.capa_instructions_endtime)
            : "";
          that.ruleForm1.capa_instructions_username =
            res.data.capa_instructions_username;
          that.ruleForm1.nocapa_reason = res.data.nocapa_reason;
          that.$nextTick(() => {
            that.ruleForm1.capa_instructions_uid = res.data
              .capa_instructions_uid
              ? res.data.capa_instructions_uid
              : "";
          });
        }
      });
    },
    //初始化时间
    initTime(value) {
      if (value) {
        return moment(value * 1000).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "/";
      }
    },
    //初始化时间
    initTime2(value) {
      if (value) {
        return moment(value * 1000).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },
    //编辑请求信息
    handleRequest() {
      let that = this;
      that.$router.push({
        path: "/CapaControl/editCapaRequest",
        query: {
          oid: that.$route.query.oid,
          step: 4,
        },
      });
    },
    checkCanNext() {
      let that = this;
      const list = that.rootCause;

      if (list.length == 0) {
        that.$message.error("Please add at least one root cause.");
        return;
      }

      for (const item of list) {
        const actionList = item.caparootcauseaction_list;
        if (!actionList || actionList.length === 0) {
          this.$message.error("Please add at least one CAPA action.");
          return;
        }
      }

      if (!that.ruleForm1.capa_verification) {
        that.$message.error(
          "Please indicate whether this CAPA request requires CAPA effectiveness verification."
        );
        return;
      }

      return true;
    },
    handleSubmit() {
      let that = this;
      if (that.step == 4) {
        if (that.checkCanNext()) {
          //调查
          that.dialogVisible2 = true;
        }
      } else {
        //初步审查
        //请求CAPA管理委员会
        capausersList({
          role_name: "",
          page: 1,
          page_size: 9999,
        }).then((res) => {
          res.data.forEach((value, index) => {
            that.ruleForm3.approvers.unshift({
              label: value.role_name,
              value: value.user_id,
            });
            that.dialogVisible3 = true;
          });
        });
      }
    },
    handleLater() {
      let that = this;
      that.$router.back();
    },
    handleReject() {
      let that = this;
      that.dialogVisible4 = true;
    },
    handleShelve() {
      let that = this;
      that.dialogVisible5 = true;
    },
    //添加更正文件
    handleEditCorrection(row) {
      let that = this;
      that.dialogVisible6 = true;
    },
    handleAvatarChange(file, fileList) {
      //上传更正文件
      let that = this;
      if (!file && !fileList) return;
      that.selectedFile = file.raw;
      that.fileName = file.name;
      that.$toast.clear();
    },
    beforeAvatarUpload(file) {
      //上传更正文件
      let that = this;
      const maxSize = 10 * 1024 * 1024; // 10MB
      const isLt100M = file.size <= maxSize;
      if (!isLt100M) {
        that.$message.error("Uploaded file size cannot exceed 10 MB");
        return false;
      }
      that.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
    },
    delFile() {
      //删除文件
      let that = this;
      that.selectedFile = null;
      that.fileName = "";
      that.$refs.uploadBox.clearFiles();
    },
    //上传更正文件确定
    submitForm6(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (!that.selectedFile) {
            that.$message.warning("Please upload a file");
            return false;
          }
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          const formData = new FormData();
          formData.append("files", that.selectedFile);
          formData.append("description", that.ruleForm6.description);
          formData.append("capa_id", that.info.id);
          formData.append("id", "");
          capaUploadsCapaCorrectionsFile(formData).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.dialogVisible6 = false;
                //请求页面详情
                that.getPageInfo();
              }, 800);
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑活动日志条目
    handleAddActivityLog(value) {
      let that = this;
      that.$router.push({
        path: "/CapaControl/activityLog",
        query: {
          oid: that.$route.query.oid,
          id: value.id,
        },
      });
    },
    //更正删除
    handleDeleteCorrection(value) {
      let that = this;
      that
        .$confirm(
          "Are you sure you want to delete this correction document?",
          "Confirmation",
          {
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          capaUploadsCapaCorrectionsFileDel({
            id: value.id,
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.getPageInfo();
              }, 800);
            }
          });
        })
        .catch(() => {});
    },

    // Add Activity Log Entry
    handleActivityLog() {
      let that = this;
      that.$router.push({
        path: "/CapaControl/activityLog",
        query: {
          oid: that.$route.query.oid,
        },
      });
    },

    handleAffectFile() {
      this.$message.success("Add Affected Document");
    },
    //添加根本原因
    handleAddRootCase() {
      let that = this;
      that.$router.push({
        path: "/CapaControl/addRootCase",
        query: {
          oid: that.$route.query.oid,
        },
      });
    },
    //展开 & 隐藏全部
    toggleAll() {
      let that = this;
      that.allExpanded = !that.allExpanded;
      if (!that.allExpanded) {
        that.rootCauseExpanded = null;
        that.correctiveExpanded = null;
      }
    },
    //展开 & 隐藏
    rootCauseExpandedClick(value) {
      let that = this;
      if (that.rootCauseExpanded == value.id) {
        that.rootCauseExpanded = null;
      } else {
        that.rootCauseExpanded = value.id;
      }
    },
    correctiveExpandedClick(value) {
      let that = this;
      if (that.correctiveExpanded == value.id) {
        that.correctiveExpanded = null;
      } else {
        that.correctiveExpanded = value.id;
      }
    },
    //根本原因添加操作
    handleAddOperation(value) {
      let that = this;
      that.$router.push({
        path: "/CapaControl/capaOperation",
        query: {
          oid: that.$route.query.oid,
          rootCaseId: value.id,
        },
      });
    },
    //根本原因编辑
    handleRootCaseEdit(value) {
      let that = this;
      that.$router.push({
        path: "/CapaControl/addRootCase",
        query: {
          oid: that.$route.query.oid,
          id: value.id,
        },
      });
    },
    //删除根本原因
    handleRootCaseDel(value) {
      let that = this;
      that
        .$confirm(
          "Are you sure you want to delete this root cause?",
          "Confirmation",
          {
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          capaRootCauseDel({
            id: value.id,
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.getPageInfo();
              }, 800);
            }
          });
        })
        .catch(() => {});
    },

    // Edit Corrective / Preventive Action
    handleMeasureEdit(value, value2) {
      let that = this;
      that.$router.push({
        path: "/CapaControl/capaOperation",
        query: {
          oid: that.$route.query.oid,
          rootCaseId: value2.id,
          id: value.id,
        },
      });
    },

    // Delete Corrective / Preventive Action
    handleMeasureDel(value) {
      let that = this;
      that
        .$confirm(
          value.capa_type == 1
            ? "Are you sure you want to delete this corrective action?"
            : "Are you sure you want to delete this preventive action?",
          "Confirmation",
          {
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          capaRootCauseActionDel({
            id: value.id,
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.getPageInfo();
              }, 800);
            }
          });
        })
        .catch(() => {});
    },
    //描述解决方案的影响
    handlelplanAffect() {
      let that = this;
      that.dialogVisible = true;
    },
    //编辑 CAPA 有效性验证计划
    handleEffectiveVerification() {
      let that = this;
      that.dialogVisible1 = true;
    },
    //编辑描述解决方案的影响
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          capaImpacts({
            id: that.ruleForm.id,
            impacts_documents: that.ruleForm.impacts_documents,
            Impacts_product: that.ruleForm.Impacts_product,
            Impacts_description:
              that.ruleForm.Impacts_product == 1
                ? that.ruleForm.Impacts_description
                : "",
            change_auth:
              that.ruleForm.Impacts_product == 1
                ? that.ruleForm.change_auth
                : "",
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.dialogVisible = false;
                //请求页面详情
                that.getPageInfo();
              }, 800);
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑 CAPA 有效性验证计划
    submitForm1(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          capaVerification({
            id: that.ruleForm1.id,
            capa_verification: that.ruleForm1.capa_verification,
            capa_instructions:
              that.ruleForm1.capa_verification == 1
                ? that.ruleForm1.capa_instructions
                : "",
            capa_instructions_uid:
              that.ruleForm1.capa_verification == 1
                ? that.ruleForm1.capa_instructions_uid
                : "",
            capa_instructions_endtime:
              that.ruleForm1.capa_verification == 1
                ? moment(that.ruleForm1.capa_instructions_endtime).valueOf() /
                  1000
                : "",
            nocapa_reason:
              that.ruleForm1.capa_verification == 2
                ? that.ruleForm1.nocapa_reason
                : "",
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.dialogVisible1 = false;
                //请求页面详情
                that.getPageInfo();
              }, 800);
            }
          });
        } else {
          return false;
        }
      });
    },
    //调查-4
    submitForm2(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          const valid = that.rootCause.every((item) => {
            return (
              item.caparootcauseaction_list &&
              item.caparootcauseaction_list.length > 0
            );
          });

          if (!valid) {
            that.$message.warning(
              "Please complete the root cause information in the solution plan."
            );
            return;
          }

          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });

          ApplyHandle({
            id: that.$route.query.oid,
            status: 2,
            remark: that.ruleForm2.remark,
            signature: md5(that.ruleForm2.signature + "AiisoQms2026"),
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.$router.push({
                  path: "/task-list",
                });
              }, 800);
            }
          });
        } else {
          return false;
        }
      });
    },

    // Initial Review - Step 5
    submitForm3(formName) {
      let that = this;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          // Approvers cannot be empty

          // Get approver values
          // const values = that.ruleForm3.approvers.map((item) => item.value);

          // // 1. Check for empty values
          // const hasEmpty = values.some(
          //   (v) => v === "" || v === null || v === undefined
          // );

          // if (hasEmpty) {
          //   this.$message.warning("Approver cannot be empty.");
          //   return;
          // }

          // // 2. Check for duplicate values
          // const hasDuplicate = new Set(values).size !== values.length;

          // if (hasDuplicate) {
          //   this.$message.warning("Approvers cannot be duplicated.");
          //   return;
          // }

          // Get approver values
          const values = that.ruleForm3.approvers.map((item) => item.value);

          // 1. At least one approver is required
          const hasValidApprover = values.some(
            (v) => v !== "" && v !== null && v !== undefined
          );

          if (!hasValidApprover) {
            this.$message.warning("At least one approver is required.");
            return;
          }

          // 2. Check for duplicate approvers (non-empty values only)
          const validValues = values.filter(
            (v) => v !== "" && v !== null && v !== undefined
          );

          const hasDuplicate = new Set(validValues).size !== validValues.length;

          if (hasDuplicate) {
            this.$message.warning("Approvers cannot be duplicated.");
            return;
          }

          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });

          ApplyHandle({
            id: that.$route.query.oid,
            status: 2,
            uids: values.join(","),
            end_time: moment(that.ruleForm3.deadline).valueOf() / 1000,
            remark: that.ruleForm3.comment,
            signature: md5(that.ruleForm3.signature + "AiisoQms2026"),
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.$router.push({
                  path: "/task-list",
                });
              }, 800);
            }
          });
        } else {
          return false;
        }
      });
    },
    //拒绝解决方案计划
    submitForm4(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          ApplyHandle({
            id: that.$route.query.oid,
            status: 3,
            end_time: moment(that.ruleForm4.response_end_time).valueOf() / 1000,
            remark: that.ruleForm4.remark,
            signature: md5(that.ruleForm4.signature + "AiisoQms2026"),
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.$router.push({
                  path: "/task-list",
                });
              }, 800);
            }
          });
        } else {
          return false;
        }
      });
    },
    //暂缓CAPA请求
    submitForm5(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          ApplyHandle({
            id: that.$route.query.oid,
            status: 3,
            priority: that.ruleForm5.priority,
            remark: that.ruleForm5.remark,
            signature: md5(that.ruleForm5.signature + "AiisoQms2026"),
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation Successful");
              setTimeout(() => {
                that.$router.push({
                  path: "/task-list",
                });
              }, 800);
            }
          });
        } else {
          return false;
        }
      });
    },
    //跳转页面
    goUrl(url) {
      let that = this;
      that.$router.push(url);
    },
  },
};
</script>
<style lang="less" scoped>
.save_box {
  .btn_box {
    text-align: right;

    .btn_el {
      margin-left: 10px;
      padding: 12px 24px;

      .van-button__text {
        font-size: 16px;
      }
    }
  }

  .form_box {
    .input_el {
      .tit {
        padding-bottom: 5px;
        font-size: 14px;
        color: #333333;
      }

      .required::before {
        content: "*";
        color: red;
        margin-right: 2px;
      }

      .full-width {
        width: 100%;
      }
    }
  }
}

//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;

    .btn_el {
      margin: 10px 0 20px 0;

      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>

<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}

.el-header,
.el-main {
  padding: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label 样式 */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

/* 输入框统一风格 */
.gray-input {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.text-tip {
  background-color: #fafafa;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

.file-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 40px;
}

.custom-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.search-input {
  width: 220px;
}

.file-table {
  width: 100%;
  margin-top: 8px;
}

.solution-plan {
  width: 100%;
  color: #303133;
  font-size: 13px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.plan-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.plan-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  margin-right: 8px;
}

.toggle-btn {
  padding: 0;
  font-size: 13px;
}

.plan-card {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
}

.plan-section {
  padding: 28px 20px 18px;
}

.section-title {
  margin: 0 0 26px;
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.sub-title {
  font-size: 20px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 20px;
}

.form-block {
  margin-bottom: 10px;
}

.field-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #303133;
}

.section-toggle {
  margin-top: 12px;
}

.section-toggle .el-button {
  padding: 0;
  font-size: 14px;
  font-weight: 600;
}

.divider {
  height: 1px;
  background: #ebeef5;
}

.section-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 8px;
}

.yellow-tip {
  margin-top: 28px;
  padding: 12px 16px;
  background-color: #fff6e6;
  border-radius: 4px;
  color: #333;
  font-size: 14px;
  line-height: 24px;
}

.list-tip ul {
  padding-left: 20px;
  margin: 6px 0 0 0;
}

.list-tip li {
  line-height: 24px;
}

.footer-btn {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-self: center;
}

.arrow-icon {
  margin-left: 4px;
  font-size: 12px;
  font-weight: bold;
}

.upload-doc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.upload-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  font-weight: 500;
}

.required-title {
  position: relative;
  padding-left: 10px;
}

.required-title::before {
  content: "*";
  position: absolute;
  left: 0;
  top: 3px;
  color: #f56c6c;
  font-size: 15px;
}

.upload-limit {
  color: #666;
  font-weight: 400;
}

.upload-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.doc-upload {
  flex-shrink: 0;
}

.file-name {
  flex: 1;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #f5f7fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}

.file-name.placeholder {
  color: #999;
}

::v-deep .el-form-item {
  margin-bottom: 16px;
}
</style>